/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/5/31 下午7:05
 */

import _ from "lodash";

export const reviewStatus = {
    none: '无',
    reviewing: '审核中',
    accepted: '已通过',
    rejected: '未通过'
};

export const lessonCdnDomain = {
    '': '默认',
    'http://cdn.ai.immusician.com': '腾讯云',
    // 'http://cdn.ai-hw.immusician.com': '华为云',
    // 'http://cdn.ai-ali.immusician.com': '阿里云'
};

export const lessonFields = {
    id: {
        title: 'ID',
        defaultValue: 0,
        disabled: true,
    },
    name: {
        title: '名称',
        defaultValue: '',
    },
    subName: {
        title: '子名称',
        defaultValue: '',
    },
    createdAt: {
        title: '创建时间',
        type: 'timestamp',
        defaultValue: 0,
    },
    updatedAt: {
        title: '更新时间',
        type: 'timestamp',
        defaultValue: 0,
    },
    videoUrl: {
        title: '主视频',
        type: 'video',
        defaultValue: '',
    },
    coverUrl: {
        title: '封面',
        type: 'image',
        defaultValue: '',
    },
    order: {
        title: '权重',
        defaultValue: 0
    },
    eventData: {
        title: '事件',
        defaultValue: ''
    },

    shareTitle: {
        title: '分享标题',
        type: 'text',
        defaultValue: ''
    },
    subShareTitle: {
        title: '分享小标题',
        defaultValue: ''
    },
    caption: {
        title: '字幕文件',
        type: 'file',
        defaultValue: ''
    },
    captionTw: {
        title: '字幕文件【繁体】',
        type: 'file',
        defaultValue: ''
    },
    teacher: {
        title: '老师',
    },
    diff: {
        title: '难度'
    },
    recommend: {
        title: '推荐课程',
    },
    level: {
        title: '课程所属等级',
    },
    hasMaterial: {
        title: '是否有素材（默认有，设否为无）',
        type: 'boolean'
    },
    is_experience: {
        title: '是否是体验课',
        type: 'boolean',
        defaultValue: false
    },
    lessonStatus: {
        title: '状态',
        defaultValue: '1'
    },
    property: {
        title: '课程属性',
        type: 'text'
    },
    recommendV2: {
        title: '推荐课程跳转',
        type: 'text'
    },
    useZip: {
        title: '是否启用压缩包',
        type: 'boolean'
    },
    zipCdnDomain: {
        title: '压缩包cdn域选择',
        type: 'zipCdnDomain',
        defaultValue: '',
    },
    couponIds: {
        title: "优惠券ID"
    },
    type:{
        title: "lesson类型",
        defaultValue: 0
    },
    sex: {
        title: "性别0-通用3-男4-女",
        defaultValue: 0
    }
};

export const lessonShareFields = {
    top_picture: {
        title: '封面1',
        type: 'image',
        defaultValue: '',
    },
    text1: {
        title: '介绍',
        defaultValue: '',
    },
    video: {
        title: '主视频',
        type: 'video',
        defaultValue: '',
    },
    bottom_picture: {
        title: '封面2',
        type: 'image',
        defaultValue: '',
    },
    text2: {
        title: '介绍2',
        defaultValue: '',
    },
    thumbnail: {
        title: '缩略图',
        type: 'image',
        defaultValue: '',
    },

};

export function getViewableFields() {
    return Object.entries(lessonFields);
}

export function getEditableFields() {
    return Object.entries(lessonFields);
}

export function getEditableShareFields() {
    return Object.entries(lessonShareFields);
}

export function getDefaultLesson() {
    return _(lessonFields).entries().map(([k, v]) => [k, v.defaultValue]).fromPairs().value()
}




// WEBPACK FOOTER //
// src/helpers/LessonsHelper.js